import { render, staticRenderFns } from "./DashboardGroups.vue?vue&type=template&id=3992b721"
import script from "./DashboardGroups.vue?vue&type=script&lang=ts"
export * from "./DashboardGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3992b721')) {
      api.createRecord('3992b721', component.options)
    } else {
      api.reload('3992b721', component.options)
    }
    module.hot.accept("./DashboardGroups.vue?vue&type=template&id=3992b721", function () {
      api.rerender('3992b721', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardGroups.vue"
export default component.exports